export default "__VITE_ASSET__u4Ugj7Il__"